import { Box, IconButton, Table, Text } from '@nimbus-ds/components';

function ConditionsListSkeleton() {
  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Text.Skeleton width="180px" />
      <Text.Skeleton width="160px" />
    </Box>
  );
}

export function MetaplansListDesktopRowSkeleton() {
  return (
    <Table.Row>
      <Table.Cell>
        <Text.Skeleton width="200px" />
      </Table.Cell>
      <Table.Cell>
        <ConditionsListSkeleton />
      </Table.Cell>
      <Table.Cell>
        <Box display="flex" gap="2">
          <IconButton.Skeleton height="2rem" width="2rem" />
        </Box>
      </Table.Cell>
    </Table.Row>
  );
}
